export const mapDataForClient = (user) => ({
  email: user.email,
  tenantId: user.tenantId,
  role: user.userRole,
  userId: user.userId,
  status: user.userStatus,
  firstName: user.firstName || '',
  lastName: user.lastName || '',
});
